import { useContext, useMemo, useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { Context_UI } from "../../Contexts/Context_UI";
import { useStatus } from "../../Contexts/Context_Status_Global";
import UI_Ribbon from "./UI_Ribbon";
import UI_Panels_Controls from "./UI_Panels_Controls";
export default function UI_Slide_Manager({ Composition }) {
    const UI = useContext(Context_UI);
    const PanelsRef = useRef(null);

    const { App_Properties_Master, Page_Properties, Page_Properties_Set, Panel_Left_State_Set, Panel_Right_State_Set, Panel_Toggle } = useStatus();
    const Location = useLocation();

    const [Slide_Previous, Slide_Previous_Set] = useState(null);

    const Properties = useMemo(() => {
        return App_Properties_Master.find(item =>
            item.Routes.includes(Location.pathname)
        );
        // return App_Properties_Master.find(item =>
        //     item.Routes.includes(Location.pathname)
        // );
    }, [UI, Location.pathname]);

    const Slide_Active = useMemo(() => {
        if (!Properties) return Composition[0];
        return Composition.find(slide => slide.Slide_ID === Properties.Slide_ID);
    }, [Composition, Properties]);


    useEffect(() => {
        if (Properties) {
            Page_Properties_Set(Properties);
        }
    }, [Properties, Page_Properties_Set]);

    // Change Apply to accept properties as an argument
    const Apply = (targetProperties) => {
        // Safety check: if properties haven't loaded yet, stop.
        if (!targetProperties || !targetProperties.Properties) return;

        const { Properties: Props, Panels } = targetProperties;

        UI.Element_InnerText_Set("Window_Title",
            `${Props.Window.Title.Primary} ${Props.Window.Title.Separator} ${Props.Window.Title.Secondary}`
        );

        const root = document.documentElement;
        root.style.setProperty("--Panel-Left-Width-Expanded", Panels.Left.Width.Expanded);
        root.style.setProperty("--Panel-Left-Width-Collapsed", Panels.Left.Width.Collapsed);
        root.style.setProperty("--Panel-Right-Width-Expanded", Panels.Right.Width.Expanded);
        root.style.setProperty("--Panel-Right-Width-Collapsed", Panels.Right.Width.Collapsed);
    }

    // Single effect to handle both Context and DOM updates
    useEffect(() => {
        if (Properties) {
            Page_Properties_Set(Properties);
            Apply(Properties);
        }
    }, [Properties, UI]); 

    // useEffect(() => {
    //     Slide_Previous_Set(Slide_Active);
    // }, [Slide_Active])

    useEffect(() => {
        Transition_Set(true);
        // console.log("Transition start");
        setTimeout(() => {
            // console.log("Transition end");
            Transition_Set(false);
            Slide_Previous_Set(null);
        }, 500);
    }, [Location.pathname]);

    const [Transition, Transition_Set] = useState(false);

    

    if (!Slide_Active && !Slide_Previous) return null;
    return (
        <>
            <UI_Ribbon Ribbon={Slide_Active.Ribbon} />
            <UI_Panels_Controls />
            <ui-panels
                id="Panels"
                State_Ribbon={Slide_Active?.Ribbon?.Active() ? "Active" : "Inactive"}
                ref={PanelsRef}
            >
                <ui-panel
                    Left
                    id="Panel_Left"
                    State={Page_Properties.Panels.Left.Enabled ? Page_Properties.Panels.Left.State : "Disabled"}>
                    <ui-panel-Slide
                        id={`Panel_Left_${Location.pathname}`}
                        State="Active"
                    >
                        {Slide_Active.Panel_Left && Slide_Active.Active() ?
                            <>
                                {Slide_Active.Panel_Left}
                            </>
                            :
                            ""
                        }
                    </ui-panel-Slide>
                </ui-panel>
                <ui-panel
                    Center
                    id="Panel_Center"
                    Margins={Page_Properties.Panels.Center.Margins ? "Active" : "Inactive"}
                >
                    <ui-panel-Slide
                        Center
                        id={`Panel_Center_${Location.pathname}`}
                        State="Active"
                    >
                        {Slide_Active.Panel_Center && Slide_Active.Active() ?
                            <>
                                {Slide_Active.Panel_Center}
                            </>
                            :
                            ""
                        }
                    </ui-panel-Slide>
                </ui-panel>


                <ui-panel
                    Right
                    id="Panel_Right"
                    State={Page_Properties.Panels.Right.Enabled ? Page_Properties.Panels.Right.State : "Disabled"}
                >
                    <ui-panel-Slide
                        Right
                        id={`Panel_Right_${Location.pathname}`}
                        State={Slide_Previous === Location.pathname ? "Inactive" : "Active"}
                    >
                        {Slide_Active.Panel_Right && Slide_Active.Active() ?
                            <>
                                {Slide_Active.Panel_Right}
                            </>
                            :
                            ""
                        }
                    </ui-panel-Slide>
                </ui-panel>

            </ui-panels>
        </>

    )
}

